import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { ProductImageSizesPortraitEnum, ProductTypes } from '@as-react/common-types';
import { capitalize } from '@as-react/common-utils';
import { memo } from 'react';
import { usePriceProps } from '../../../hooks/usePriceProps';
import { getImageUrlForBasketTile } from '../../../util/ImageUtil';
import AsNumeral from '../../../vendors/asNumeral';
import { ProductTileCompact } from '../../product-tile/compact/ProductTileCompact';
const BasketProductItemBase = ({ basketProductData, tileType, dataQA, asStatic, withOriginalSize, }) => {
    const { root, productImageConfig } = useAemConfig();
    const image = getImageUrlForBasketTile(basketProductData, productImageConfig, ProductImageSizesPortraitEnum.thumb);
    const seoUrl = `${root}p${basketProductData.seoUrl}.html?colour=${basketProductData.colorId}`;
    const color = basketProductData.color ? capitalize(basketProductData.color) : '';
    const priceActual = {
        formattedPrice: AsNumeral.formatAsCurrency(basketProductData.totalPrice),
    };
    const pricePrevious = basketProductData.productHasDiscount && !!basketProductData.totalPreviousPrice
        ? {
            formattedPrice: AsNumeral.formatAsCurrency(basketProductData.totalPreviousPrice),
        }
        : undefined;
    const priceReference = basketProductData.productHasDiscount && !!basketProductData.lowestPrice
        ? {
            formattedPrice: AsNumeral.formatAsCurrency(basketProductData.lowestPrice),
        }
        : undefined;
    const priceProps = usePriceProps({
        priceInformation: {
            prices: basketProductData.prices,
            hasDiscount: Boolean(basketProductData.productHasDiscount),
        },
        fallbackPriceViewModel: {
            priceActual,
            pricePrevious,
            priceReference,
        },
    });
    return (_jsx(ProductTileCompact, Object.assign({ type: tileType, brand: basketProductData.brand, quantity: basketProductData.quantity, image: image, url: seoUrl, title: basketProductData.description, dataQA: dataQA, asStatic: asStatic, priceProps: priceProps }, (basketProductData.productType === ProductTypes.PRODUCT
        ? {
            sizeDescription: !withOriginalSize ? basketProductData.sizeDescription : basketProductData.originalSize,
            colorDescription: color,
        }
        : {}))));
};
export const BasketProductItem = memo(BasketProductItemBase);
